import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { fetchPostById, fetchAllPosts, LINKEDIN_URL } from '../data/blogData';
import { SITE } from '../data/siteData';
import './BlogDetail.css';
import Icon from '../components/Icon';

export default function BlogDetail() {
  const { id } = useParams();
  const [post, setPost] = useState(undefined); // undefined = loading, null = not found
  const [related, setRelated] = useState([]);

  useEffect(() => {
    let alive = true;
    setPost(undefined);
    fetchPostById(id).then(p => { if (alive) setPost(p || null); });
    fetchAllPosts().then(all => {
      if (alive) setRelated(all.filter(p => String(p.id) !== String(id)).slice(0, 3));
    });
    return () => { alive = false; };
  }, [id]);

  if (post === undefined) {
    return (
      <div className="blog-detail-page">
        <div className="bd-missing container"><p>Loading…</p></div>
      </div>
    );
  }

  if (post === null) {
    return (
      <div className="blog-detail-page">
        <div className="bd-missing container">
          <h1>Article not found</h1>
          <p>This article may have been removed.</p>
          <Link to="/blogs" className="btn-primary">← Back to Blog</Link>
        </div>
      </div>
    );
  }

  const paragraphs = (post.body || post.excerpt).split('\n').filter(p => p.trim());

  return (
    <div className="blog-detail-page">
      {/* Hero */}
      <section className="bd-hero" style={{ backgroundImage: `url(${post.img})` }}>
        <div className="bd-hero-overlay" />
        <div className="bd-hero-content container">
          <span className="bd-tag">{post.tag}</span>
          <h1 className="bd-title">{post.title}</h1>
          <div className="bd-meta">
            <span>✍️ {post.author}</span>
            <span>{post.date}</span>
            <span>⏱ {post.read}</span>
          </div>
        </div>
      </section>

      {/* Body */}
      <article className="bd-body container">
        <Link to="/blogs" className="bd-back">← Back to all articles</Link>
        {paragraphs.map((p, i) => (
          <p key={i} className="bd-para">{p}</p>
        ))}

        <div className="bd-share">
          <a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer" className="bd-li-btn">
            <span className="bd-li-icon">in</span> View More on LinkedIn →
          </a>
        </div>
      </article>

      {/* Related */}
      {related.length > 0 && (
        <section className="bd-related container">
          <h2 className="bd-related-title">More Articles</h2>
          <div className="bd-related-grid">
            {related.map(r => (
              <Link key={r.id} to={`/blog/${r.id}`} className="bd-rel-card">
                <div className="bd-rel-img" style={{ backgroundImage: `url(${r.img})` }} />
                <div className="bd-rel-body">
                  <span className="bd-rel-tag">{r.tag}</span>
                  <h3>{r.title}</h3>
                </div>
              </Link>
            ))}
          </div>
        </section>
      )}

      {/* CTA */}
      <section className="blogs-cta">
        <div className="container" style={{ textAlign: 'center' }}>
          <h2 className="section-title">Have a Financial Question?</h2>
          <p className="section-sub" style={{ maxWidth: 480, margin: '12px auto 32px' }}>
            Talk to our experts and get guidance tailored to your goals.
          </p>
          <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href={`tel:${SITE.contact.phone}`} className="btn-primary">📞 Talk to an Advisor</a>
            <Link to="/contact" className="btn-ghost">Send a Question →</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
